const defaultState = (proxyLoading = false, closeTab = false) => ({});

export default (state = defaultState(), {type, payload}) => {
    switch (type) {
        case "CURRENT-CONNECTOR:UPDATE-CONFIG-SUCCESS": {
            return {...state, config: {...state.config, ...payload}}
        }
        case "CONNECTOR-SETTINGS:FETCH-CONFIG-PENDING": {
            return {...state, config: null}
        }
        case "CONNECTOR-SETTINGS:FETCH-CONFIG-SUCCESS": {
            const {config} = payload;
            return {...state, config}
        }
        case "CONNECTOR-SETTINGS:UPDATE-CLOSE-TAB": {
            return {...state, closeTab: false}
        }
        default: {
            return state;
        }
    }
};
